import CreditEntry from "./CreditEntry";
import Subscription from "./Subscription";
import Payment from "./Payment";
import Entity from "./Entity";

export default class Credit {
  fields = {
    id: {
      value: null
    },
    readable_id: {
      value: null
    },
    subscription: {
      value: null
    },
    payment: {
      value: null
    },
    subscription_id: {
      value: null
    },
    payment_meta: {
      value: {}
    },
    payment_type: {
      value: null
    },
    payment_id: {
      value: null
    },
    amount: {
      value: null
    },
    balance: {
      value: null
    },
    notes: {
      value: null
    },
    credit_entries: {
      value: []
    },
    created_at: {
      value: null
    },
    application_type: {
      value: null
    },
  }

  static createFromQueryValues(values) {
    const credit = new this();

    for (let field in credit.fields) {
      if (values.hasOwnProperty(field)) {
        switch(field) {
          case 'created_at':
            credit.fields[field].value = (values[field] === null) ?
              values[field] :
              new Date(Number(values[field]));
            break;
          case 'subscription':
            credit.fields[field].value = (values[field] === null) ?
              values[field] :
              Subscription.createFromQueryValues(values[field]);
            break;
          case 'credit_entries':
            if (Array.isArray(values[field])) {
              credit.fields[field].value = values[field].map(entry => CreditEntry.createFromQueryValues(entry));
            }
            break;
          case 'payment': 
            credit.fields[field].value = (values[field] === null) ?
              values[field] :
              Payment.createFromQueryValues(values[field]);
            break;
          default:
            credit.fields[field].value = values[field];
        }
      }
    }

    return credit;
  }

  static async getSelectableApplicationTypes() {
    const response = await Entity.getFieldAllowedValues(
      {},
      { application_type: { enumName: 'CreditApplicationTypeEnum' } },
      ['application_type'],
    );

    const appTypeOptions = response.application_type.options;

    const selectableOptions = appTypeOptions.filter(({ label }) => (
      ['Apply Cash', 'Do Not Apply Cash'].includes(label)
    ));

    return selectableOptions;
  }

  getQueryFieldValues() {
    const values = {
      subscription_id: this.fields.subscription_id.value,
      payment_id: this.fields.payment_meta.value.check_number,
      payment_type: this.fields.payment_type.value,
      application_type: this.fields.application_type.value,
      amount: this.getAmount(),
      notes: this.fields.notes.value,
    };

    // when the payment type is carryover credit or discount credit, the payment
    // id input becomes optional. this sets the input's value to a default since
    // the value would otherwise be blank
    const paymentIdNotRequired = values.payment_type === 'CARRYOVER_CREDIT'
      || values.payment_type === 'DISCOUNT_CREDIT';
    if (paymentIdNotRequired && !values.payment_id) {
      values.payment_id = '';
    }

    if (this.fields.credit_entries.value.length) {
      const entry = this.fields.credit_entries.value[0].fields;
      values.credit_entry = {
        amount: entry.amount.value,
        amount_tax_1: entry.amount_tax_1.value,
        amount_tax_2: entry.amount_tax_2.value,
        amount_tax_3: entry.amount_tax_3.value,
        amount_tax_4: entry.amount_tax_4.value,
        type: entry.type.value
      }
    }

    return values;
  }

  getUpdateQueryFieldValues() {
    const newEntry = this.fields.credit_entries.value.find(entry => !entry.fields.id.value);
    const newEntryFields = newEntry ? {
      credit_entry: {
        amount: newEntry.fields.amount.value,
        amount_tax_1: newEntry.fields.amount_tax_1.value,
        amount_tax_2: newEntry.fields.amount_tax_2.value,
        amount_tax_3: newEntry.fields.amount_tax_3.value,
        amount_tax_4: newEntry.fields.amount_tax_4.value,
        type: newEntry.fields.type.value
      }
    } : {}
    return {
      credit_id: this.fields.id.value,
      notes: this.fields.notes.value,
      ...newEntryFields,
    };
  }

  getAmount() {
    return this.fields.credit_entries.value.reduce((amount, entry) => {
      switch(entry.fields.type.value) {
        case 'CREATION':
        case 'OVERPAYMENT':
          amount += entry.fields.amount.value;
          amount += entry.fields.amount_tax_1.value;
          amount += entry.fields.amount_tax_2.value;
          amount += entry.fields.amount_tax_3.value;
          amount += entry.fields.amount_tax_4.value;
          break;
        default:
      }

      return amount;
    }, 0);
  }
}

